import React from 'react';
import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section className="relative min-h-[90vh] flex flex-col items-center justify-center overflow-hidden px-6 py-24" data-id="element-68">
      {/* Abstract kinetic background element */}
      <motion.div className="absolute w-[600px] h-[600px] bg-magenta-500/10 rounded-full blur-3xl pointer-events-none" animate={{
      scale: [1, 1.2, 1],
      x: [0, 50, 0],
      y: [0, -50, 0]
    }} transition={{
      duration: 15,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-69" />
      <motion.div className="absolute w-[500px] h-[500px] bg-cyan-500/10 rounded-full blur-3xl pointer-events-none" animate={{
      scale: [1, 1.3, 1],
      x: [0, -60, 0],
      y: [0, 40, 0]
    }} transition={{
      duration: 18,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-70" />

      <div className="relative z-10 max-w-5xl mx-auto text-center flex flex-col items-center" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-zinc-900 border border-zinc-800 text-xs font-medium text-zinc-400 mb-8 tracking-wide uppercase" data-id="element-72">
          <span className="w-2 h-2 rounded-full bg-magenta-500 animate-pulse" data-id="element-73" />
          {t('hero.badge')}
        </motion.div>
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="font-serif italic text-magenta-400/90 text-2xl sm:text-3xl md:text-4xl -mt-4 mb-8" data-id="element-74">
          {t('hero.subBadge')}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} className="w-full max-w-3xl mb-4" data-id="element-75">
          <div className="relative" data-id="element-76">
            <img src="https://cdn.magicpatterns.com/uploads/an7aTMn8v3udhR5ryjHUfw/dance_for_fans_logo.png" alt="Dance for Fans" className="w-full h-auto rounded-2xl" data-id="element-77" />
            {/* Cover the baked-in "2024" in the logo's bottom right corner */}
            <div className="absolute bottom-[3%] right-[3%] w-[20%] h-[14%] rounded-md" style={{
            backgroundColor: '#1a0d2e'
          }} aria-hidden="true" data-id="element-78" />
            <span className="absolute bottom-[4%] right-[4%] text-cyan-300 font-serif tracking-wider text-xs sm:text-sm md:text-base lg:text-lg" style={{
            textShadow: '0 0 8px rgba(103, 232, 249, 0.9), 0 0 16px rgba(103, 232, 249, 0.5)'
          }} data-id="element-79">
              {t('hero.future')}
            </span>
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="font-serif text-2xl md:text-3xl tracking-tight text-zinc-300 mb-4" data-id="element-80">
          danceforfans<span className="text-magenta-500" data-id="element-81">.com</span>
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-xl md:text-2xl text-zinc-400 font-light mb-12 italic font-serif" data-id="element-82">
          {t('hero.tagline')}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="flex flex-col sm:flex-row items-center gap-4" data-id="element-83">
          <a href="mailto:jose@danceforfans.com" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-magenta-500 text-white rounded-full font-medium hover:bg-magenta-600 transition-colors w-full sm:w-auto" data-id="element-84">
            <Mail className="w-5 h-5" data-id="element-85" />
            {t('hero.contactBtn')}
          </a>
          <a href="mailto:jose@danceforfans.com" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-zinc-900 text-zinc-300 rounded-full font-medium hover:bg-zinc-800 transition-colors w-full sm:w-auto border border-zinc-800" data-id="element-86">
            {t('hero.callBtn')}
          </a>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.7
      }} className="mt-12 font-serif italic text-cyan-300 text-2xl sm:text-3xl md:text-4xl tracking-wide" style={{
        textShadow: '0 0 12px rgba(103, 232, 249, 0.6), 0 0 24px rgba(103, 232, 249, 0.3)'
      }} data-id="element-87">
          This page will be coming soon!
        </motion.p>
      </div>
    </section>;
}